import { API_ENDPOINTS } from "../constants";
import { apisClient as api } from "./api";

export const generateAuthToken = () =>
  api.get(`${API_ENDPOINTS.SALESFORCE}/customer/auth`);
